export const formatSubscriberIdApiUrl = (subscriberId: string, url: string) =>
    `/subscriber/${subscriberId}/${url}`;
